import { Dictionary } from "@/lib/Dictionary.type";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";
import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import { ResourceCollection } from "@/modules/api/resource.collection";

import FactoryPhaseSupport from "./factory-phase-support.model";

export default class FactoryPhaseSupportRepository extends BasicRepository<FactoryPhaseSupport> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<FactoryPhaseSupport>,
    responseParser: ApiCollectionResponseParserService<FactoryPhaseSupport>
  ) {
    super("factory_phase_supports", api, objectBuilder, responseParser);
  }

  public getByFactoryId(
    factoryId: string,
    useCache = true
  ): Promise<ResourceCollection<FactoryPhaseSupport>> {
    return this.getList(1, 999, { factory: factoryId }, undefined, useCache);
  }

  public async create(item: FactoryPhaseSupport): Promise<FactoryPhaseSupport> {
    const response = await this.api.post(
      this.resourceName,
      this.prepareData(item)
    );

    return this.objectBuilder.buildFromJSON(response.data);
  }

  protected prepareData(
    item: FactoryPhaseSupport
  ): Dictionary<string | number | boolean | string[]> {
    return {
      id: item.id,
      factory: item.factory,
      slotType: item.slotType,
    };
  }
}
